import { ownerRepository } from '@/repositories/OwnerRepository'
import type { OwnerWithPropertyCount } from '@/types'
import { useParams } from 'react-router-dom'
import { useData } from './useData'

export function useOwner() {
  const { id } = useParams<{ id: string }>()
  const { data, isLoading, error, refetch } = useData<OwnerWithPropertyCount>({
    repository: ownerRepository,
    fetcher: (repo) => repo.getById(id!),
    queryKey: ['owner', id],
  })

  return {
    data: (data as OwnerWithPropertyCount) ?? null,
    isLoading,
    error,
    refetch,
  }
}
